import { createMockListResponse as s } from "../../../helpers/CreateMockListResponse.js";
const t = (e) => ({
  id: `batch-${e}`,
  name: `Batch Answer ${e}`,
  createdOn: "2021-01-01T00:00:00Z",
  createdBy: {
    userId: "user-Id",
    fullName: "Daniel Rosenfeld"
  },
  totalRuns: e + 1,
  queryPipeline: {
    id: `pipeline-${e}`,
    name: `Pipeline ${e}`
  },
  datasetSummary: {
    id: `dataset-${e}`,
    name: `Dataset ${e}`,
    totalQueries: 100 + e
  },
  facets: [],
  customContext: {},
  credentials: {
    type: "ANONYMOUS"
  },
  runsStatistics: [
    {
      startDate: "2021-01-01T00:00:00Z",
      answerRate: 0.5,
      isCompleted: !0
    },
    {
      startDate: "2021-02-01T00:00:00Z",
      answerRate: 0.6,
      isCompleted: !0
    },
    {
      startDate: "2021-03-01T00:00:00Z",
      answerRate: 1,
      isCompleted: !0
    },
    {
      startDate: "2021-04-01T00:00:00Z",
      answerRate: 0.1,
      isCompleted: !0
    },
    {
      startDate: "2021-05-01T00:00:00Z",
      answerRate: 0,
      isCompleted: !0
    }
  ]
}), o = (e) => s(
  t,
  (a) => a.name.includes(e ?? "")
), c = (e) => t(0), n = () => t(0);
export {
  n as createMockBatchAnswerGetResponse,
  t as createMockBatchAnswerItem,
  o as createMockBatchAnswerListResponse,
  c as createMockEvaluationCreationResponse
};
//# sourceMappingURL=BatchAnswerEvaluations.mocks.js.map
